module.exports = __webpack_public_path__ + "img/laddercontrol6.3aacf896.png";